/**
 * env.js — inject Vite env into window.__PROMPTO_ENV__ for src/config/config.js.
 * Imported FIRST in main.jsx so it evaluates before config.js ever loads.
 */
window.__PROMPTO_ENV__ = {
  ...(window.__PROMPTO_ENV__ || {}),
  USE_MOCK: parseEnvBool(import.meta.env.VITE_USE_MOCK, true),
  ...(import.meta.env.VITE_API_BASE_URL ? { API_BASE_URL: import.meta.env.VITE_API_BASE_URL } : {}),
  ...(import.meta.env.VITE_GOOGLE_CLIENT_ID ? { GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID } : {}),
  ...(import.meta.env.VITE_GOOGLE_REDIRECT_URI ? { GOOGLE_REDIRECT_URI: import.meta.env.VITE_GOOGLE_REDIRECT_URI } : {}),
  ...(import.meta.env.VITE_KAKAO_REST_KEY ? { KAKAO_REST_KEY: import.meta.env.VITE_KAKAO_REST_KEY } : {}),
  ...(import.meta.env.VITE_KAKAO_JS_KEY ? { KAKAO_JS_KEY: import.meta.env.VITE_KAKAO_JS_KEY } : {}),
  ...(import.meta.env.VITE_KAKAO_REDIRECT_URI ? { KAKAO_REDIRECT_URI: import.meta.env.VITE_KAKAO_REDIRECT_URI } : {}),
  ...(import.meta.env.VITE_FEATURE_GENERATION !== undefined ? { FEATURE_GENERATION: import.meta.env.VITE_FEATURE_GENERATION } : {}),
  ...(import.meta.env.VITE_FEATURE_SOCIAL !== undefined ? { FEATURE_SOCIAL: import.meta.env.VITE_FEATURE_SOCIAL } : {}),
  ...(import.meta.env.VITE_FEATURE_DOWNLOAD !== undefined ? { FEATURE_DOWNLOAD: import.meta.env.VITE_FEATURE_DOWNLOAD } : {}),
  ...(import.meta.env.VITE_FEATURE_OAUTH_GOOGLE !== undefined ? { FEATURE_OAUTH_GOOGLE: import.meta.env.VITE_FEATURE_OAUTH_GOOGLE } : {}),
  ...(import.meta.env.VITE_FEATURE_OAUTH_KAKAO !== undefined ? { FEATURE_OAUTH_KAKAO: import.meta.env.VITE_FEATURE_OAUTH_KAKAO } : {}),
};

function parseEnvBool(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "boolean") return value;
  const normalized = String(value).trim().toLowerCase();
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  return fallback;
}
